import 'apps/hiring/styles/components/applicant/target-data-header.scss';
import 'apps/hiring/styles/components/evaluate-applicant-list.scss';
import React from 'react';
import { Link } from 'library/util/core-router';
import PropTypes from 'prop-types';
import MatchScore from 'library/components/target-match-score';
import ReadinessReport from 'library/components/download-report';
import PencilSvg from 'library/icons/pencil.svg';
import ReadMore from 'library/components/read-more';
import EditTarget from 'apps/hiring/components/edit-target';
import TargetsSvg from 'library/icons/targets.svg';
import { strip_tags } from 'library/helpers/text';

class TargetDataHeader extends React.Component {
  static propTypes = {
    match: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    description: PropTypes.string,
    targetId: PropTypes.number,
    user: PropTypes.object,
    closed: PropTypes.bool,
    openingId: PropTypes.number
  }

  render() {
    const {
      match,
      name,
      description,
      targetId,
      user,
      closed,
      openingId
    } = this.props;

    return (
      <div className="hiring-evaluate-content">
        <div className="hiring-evaluate-content-header">
          <Link to={`/hiring/openings/${openingId}/evaluate`} className="target-header-view-in-group button">
          View in group
          </Link>
          <div className="hiring-evaluate-content-header-inner">
            <h1 style={{width: 'calc(100% - 135px)'}}>
              <span>{name}</span> Target
              <EditTarget
                node_id={openingId}
                disabled={closed}
                component="span"
                className="button-noborder-theme"
                id={targetId}
              >
                <PencilSvg />
              </EditTarget>
              <ReadinessReport
                reportType="readiness"
                data={{user_id: user.id, opening_id: openingId, target_id: targetId}}
                component='span'>
                <TargetsSvg />
              </ReadinessReport>
            </h1>
            { strip_tags(description||'').length > 0 ?
              <ReadMore defaultHeight={61}>
                <p dangerouslySetInnerHTML={{__html: description||''.replace(new RegExp(`(\\<\\/?p\\s?\\>|\\<p\\s?\\/\\>)`, 'g'), '')}} />
              </ReadMore>
              : null
            }
          </div>
        </div>
        <h3> <span> Match Score: </span> {match} </h3>
      </div>
    );
  }
}

export default TargetDataHeader;
